import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Loader2, Repeat, Layers } from "lucide-react";

const inr = (n) => (n == null ? "—" : "₹" + Number(n).toLocaleString("en-IN", { maximumFractionDigits: 2 }));

export default function OurSubscriptions() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/subscriptions/customer/overview").then((r) => setD(r.data)).catch(() => setD({ contracts: [], subscriptions: [], invoices: [] })); }, []);
  if (!d) return <div className="py-20 text-center text-slate-400"><Loader2 className="h-5 w-5 animate-spin inline" /></div>;
  return (
    <div className="max-w-4xl mx-auto p-5 space-y-5" data-testid="our-subscriptions-page">
      <div>
        <div className="text-[10px] font-semibold tracking-[0.14em] uppercase text-slate-500">Services</div>
        <h1 className="text-3xl font-semibold text-slate-900 tracking-tight mt-1">Our Subscriptions</h1>
        <p className="text-sm text-slate-600 mt-1">Your active contracts, managed assets, usage and billing.</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        <Kpi icon={Layers} label="Active contracts" value={d.contracts.length} />
        <Kpi icon={Repeat} label="Managed assets" value={d.managed_assets} />
        <Kpi label="Invoices" value={d.invoices.length} />
      </div>

      <div className="rounded-xl border border-slate-200 bg-white">
        <div className="px-4 py-2 text-[11px] font-semibold uppercase tracking-wide text-slate-400 border-b border-slate-100">Recent invoices</div>
        {d.invoices.length === 0 ? <div className="py-10 text-center text-sm text-slate-400" data-testid="our-subs-empty">No invoices yet.</div> :
          d.invoices.map((inv, i) => (
            <div key={i} className="px-4 py-3 border-b border-slate-50" data-testid={`our-inv-${i}`}>
              <div className="flex items-center justify-between">
                <div><div className="text-sm font-medium text-slate-800">{inv.invoice_no} · {inv.period}</div>
                  <div className="text-[12px] text-slate-500">{inv.lines?.length || 0} line(s)</div></div>
                <div className="text-right"><div className="font-semibold tabular-nums">{inr(inv.total)}</div>
                  <Badge className="text-[10px] border bg-emerald-50 text-emerald-700 border-emerald-200">{inv.status}</Badge></div>
              </div>
              <div className="mt-1.5 space-y-0.5">{(inv.lines || []).map((l, j) => (
                <div key={j} className="flex justify-between text-[12px] text-slate-500"><span>{l.description} (qty {l.qty})</span><span className="tabular-nums">{inr(l.amount)}</span></div>))}</div>
            </div>
          ))}
      </div>
    </div>
  );
}
const Kpi = ({ icon: Icon, label, value }) => (
  <div className="rounded-xl border border-slate-200 bg-white p-4">
    <div className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-wide text-slate-500">{Icon && <Icon className="h-3.5 w-3.5" />}{label}</div>
    <div className="mt-1 text-2xl font-semibold tabular-nums text-slate-900">{value}</div>
  </div>
);
